import { Component } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { motion } from "framer-motion";
import { FaBuilding, FaCheck } from "react-icons/fa";

import { FaPeopleRobbery } from "react-icons/fa6";
import { BsCheck2Circle } from "react-icons/bs";
import "./index.css";

class AboutUs extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>
            About Us | Hassle-Free Valet Trash Collection for Apartment
            Communities, in Peroria IL
          </title>
          <meta
            name="description"
            content="Discover our convenient valet trash collection services, offering seamless waste pickup directly from residents’ doors in Peoria, IL, and surrounding areas."
          />
          <link
            rel="canonical"
            href="https://simpletrashsolutionsllc.com/about-us"
          />
        </Helmet>
        <NavBar />
        <div className="about-main-container">
          <section className="top-banner-section">
            <div className="banner-section">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-center"
              >
                <h1 className="banner-section-heading">
                  Upgrade Your Apartments with Hassle-Free Door-to-Door Trash
                  Pickup!
                </h1>
                <p className="banner-section-para">
                  Transform your property management with our premium valet
                  trash collection service. Our dependable Door-to-Door trash
                  pickup offers a convenient solution for both property owners
                  and tenants, ensuring a cleaner and more organized community.
                </p>
              </motion.div>
            </div>
          </section>

          {/* Main Content */}
          <section className="service-section">
            <div className="service-container">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <h2 className="service-heading">Our Premium Service</h2>
                <div className="service-content-container">
                  <p className="service-para">
                    At just $15 per unit per month, we manage all trash
                    collection logistics, allowing you to focus on other
                    priorities. Our services include professional valet trash
                    collection and affordable trash removal. Plus, we donate 10%
                    of our revenue to the American Red Cross, giving back to the
                    community
                  </p>
                  <p className="service-para additional">
                    <b>Aditional Services:</b>
                  </p>
                  <ul className="additional-list">
                    <li>
                      <FaCheck className="add-icon" />
                      $5 per unit for a month’s supply of trash bags
                    </li>
                    <li>
                      <FaCheck className="add-icon" />
                      $50 per month for dog park cleanup and pet waste bag
                      refills
                    </li>
                    <li>
                      <FaCheck className="add-icon" />
                      $10 per external dumpster cleaning
                    </li>
                    <li>
                      <FaCheck className="add-icon" />
                      Combo trash and recycling bin rental at an affordable
                      price
                    </li>
                    <li>
                      <FaCheck className="add-icon" />
                      Hallway steam cleaning at an affordable price (reduces
                      bacteria by 99%)
                    </li>
                  </ul>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <img
                  src="/trash-pickup-for-apartment.webp"
                  alt="Apartment Trash Valet Collection"
                  className="service-img"
                />
              </motion.div>
            </div>
          </section>

          {/*Founder Introduction */}

          <section className="profile-section">
            <div className="profile-content-container">
              <img
                src="/founder-image.webp"
                alt="founder of simple trash solutions"
                className="profile-image"
              />
              <div className="intro-content">
                <h1 className="name">Shawn Smothers</h1>
                <h2>Founder - Simple Trash Solutions LLC</h2>
                <p>
                  Simple Trash Solutions is dedicated to offering affordable and
                  reliable valet trash services tailored for apartment
                  buildings. With flexible contract options, we ensure
                  convenience for both property owners and tenants. Our trash
                  pickup service is designed for maximum satisfaction.
                </p>
              </div>
            </div>
          </section>

          {/* Benefits Section */}
          <section className="benefits-main-section">
            <div className="benefits-section">
              <h2 className="benefits-heading">Why Property Owners Love Us</h2>
              <p className="benefits-para">
                Our Trash Pickup Service adds value to your property while
                generating additional revenue
              </p>

              <div className="benefits-card-container">
                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  viewport={{ once: true }}
                  className="card-container benefits"
                >
                  <FaBuilding className="icons" />
                  <h1 className="benefit-card-heading">Property Value</h1>
                  <p className="benefit-card-para">
                    Enhance your property's appeal with premium amenities
                  </p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="card-container benefits"
                >
                  <FaPeopleRobbery className="icons" />
                  <h1 className="benefit-card-heading">Tenant Satisfaction</h1>
                  <p className="benefit-card-para">
                    Provide convenience that residents truly appreciate
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.8 }}
                  viewport={{ once: true }}
                  className="card-container benefits"
                >
                  <BsCheck2Circle className="icons" />
                  <h1 className="benefit-card-heading">Hassle-Free</h1>
                  <p className="benefit-card-para">
                    Let your tenants stay clean and safe—leave their trash
                    collection to us.
                  </p>
                </motion.div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default AboutUs;
